import React from 'react';
import { FeatureContextType } from './types';

export const FeatureContext = React.createContext<
  FeatureContextType | undefined
>(undefined);
